module.exports = __webpack_public_path__ + "img/care-offer-3.e9389198.jpg";